<template>
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9.33722 14.9262C12.6099 14.9262 15.263 12.2727 15.263 8.99958C15.263 5.72642 12.6099 3.073 9.33722 3.073C6.06454 3.073 3.4115 5.72642 3.4115 8.99958C3.4115 12.2727 6.06454 14.9262 9.33722 14.9262Z" stroke="currentColor" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M16.7448 16.4064L13.5227 13.1838" stroke="currentColor" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
</template>
